// Enkel delad spärr: när admin skapar en ny medarbetare loggar Supabase tillfälligt
// in webbläsaren som den NYA användaren (ett känt Supabase-beteende hos signUp()).
// Genom att sätta den här flaggan under hela processen vet useAuth att ignorera
// de tillfälliga inloggningsändringarna helt, istället för att försöka reda ut
// i efterhand vilken som var "senast" (vilket blev en kapplöpning som gick fel).
let blockerad = false

export function blockeraAuthLyssnare() {
  blockerad = true
}

export function avblockeraAuthLyssnare() {
  blockerad = false
}

export function arBlockerad() {
  return blockerad
}
